<div id="userList-loading" class="user-loading-container loader load-{{isDataLoading()}}">
  <div class="ndnqi-spinner">
    <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
  </div>
</div>


<ng-container *ngIf="hospid">

  <div class="container-fluid">
        <div>
          <h6 class="title">   <!-- tried these diff titles (looked the same): modal-title, indicator-title, tabcontrol-title-->
            Manage Users
          </h6>
        <div class="form-group">
                   
            <!-- API Message --> <!-- [innerHTML] attribute binding to render HTML content: which we will be using for newline characters <br>, that comes from db 'msg' column (eventually to getAPIMessage in service) -->
             <div class="message-label" [innerHTML]="message?.text" [ngClass]="message?.class">{{ message?.text }}</div>  
            <br>
            
            <!-- User Selection -->
            <ng-container *ngIf="userData">

              <div class="row">
                <div class="col-sm-4">
                  <label for="userSelection">User Selection</label>
                  <select class="form-control custom-select" style="font-size:14px" (change)="onUserSelectionChange($event.target.value)"
                    [(ngModel)]="selectedUser" [value]="selectedUser">
                    <option value=0></option>
                    <option *ngFor="let user of userData; trackBy: trackById" [value]="user.facilityUserID">{{ user.userLastName }}, {{ user.userFirstName }}               
                    </option>
                  </select>        
                </div>
                        
                <div class="col-sm-6"  [hidden]="isLastLoginDateHidden()">
                  <label name="lastLoginDate"><i><br><br>Last Login Date: {{ lastLoginDate }}</i></label> 
                </div>
              </div>

            </ng-container>
<p></p>
            <!-- User Role -->
            <ng-container *ngIf="userRoleData"> 
            
              <div class="row">
                <div class="col-sm-4">
                  <!-- From Year  -->
                  <label>User Role</label>
                  <select class="form-control custom-select" style="font-size:14px" (change)="onUserRoleSelectionChange($event.target.value)"
                    [value]="selectedUserRole"
                    [(ngModel)]="selectedUserRole"
                    [disabled]="isRoleDisabled">
                    <option *ngFor="let role of userRoleData" [value]=role.roleID>{{role.role}}
                    </option> 
                  </select>
                </div>
              </div>

            </ng-container>
<p></p>
            <!-- Activate User -->
            <div class="row" [hidden]="isActivateHidden">
              <div class="col-sm-6">
                <input type="checkbox" 
                [(ngModel)]="isActive" 
                [disabled]="isActiveChkbxDisabled"
                (change)="onActiveChange()">
                Activate User
              </div>
            </div>

            <p-confirmDialog key="deleteUserConfirmation"></p-confirmDialog>

            <p></p><br>     

            <div class="tabcontrol-title">  
              User Access
            </div>  
              
<p></p> 
            <!-- Main Menu and Data Entry Tabs -->
                <nav>           
                  <div class="nav nav-tabs customTabber" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-main-menu-access-tab" data-bs-toggle="tab" data-bs-target="#nav-main-menu-access" role="tab"
                      aria-controls="nav-main-menu-access" aria-selected="true">Main Menu Access</a>
                    <a *ngIf="showTab" class="nav-item nav-link" id="nav-data-entry-access-tab" data-bs-toggle="tab" data-bs-target="#nav-data-entry-access" role="tab"
                      aria-controls="nav-data-entry-access" aria-selected="false">Data Entry Access</a>
                  </div> 
                </nav>

                <div class="tab-content" id="nav-tabContent">
                  <div class="tab-pane fade show active" id="nav-main-menu-access" role="tabpanel" aria-labelledby="nav-main-menu-access">
                    <app-menu-access
                    (mainMenuSaveSuccess)="onMainMenuSaveSuccess($event)"
                     [editUserForm]="editUserForm" 
                     [selectedUserId]="selectedUser" 
                     [selectedUserRole]="selectedUserRole"  
                     [mainMenuForceCheckedIndicators]="mainMenuForceCheckedIndicators"  
                     [mainMenuForceUncheckedIndicators]="mainMenuForceUncheckedIndicators"
                     [isPowerUser] = "isPowerUser"> <!--to be passed to child component: main-menu-access-->
                    </app-menu-access>
                  </div>

                  <div class="tab-pane fade" id="nav-data-entry-access" role="tabpanel" aria-labelledby="nav-data-entry-access-tab">                    
                    <app-data-entry-access 
                    (dataEntrySaveSuccess)="onDataEntrySaveSuccess($event)"
                     [editUserForm]="editUserForm"
                     (showTab)="checkDataEntryTabStatus($event)" 
                     [selectedUserId]="selectedUser"
                     [selectedUserRole]="selectedUserRole"
                     [isPowerUser] = "isPowerUser"> <!--to be passed to child component: data-entry-access-->
                  </app-data-entry-access>
                  </div>
                </div>  
<br>


          <!-- Buttons -->
            <div class="col-sm-4 btngroup">
              <button (click)="onSave(hospid)" 
                tabindex="0" 
                class="btn btn-primary btn-sm mr-3 float-left"  
                type="submit"
                [hidden]="isSaveHidden"> Save 
              </button>
              <button type="button" tabindex="-1" class="btn btn-secondary btn-sm mr-3 float-left" (click)="onCancelUser()" [hidden]="isCancelHidden(selectedUser)"> Cancel </button>
              <button type="submit" tabindex="-1" class="btn btn-secondary btn-sm mr-3 float-left" (click)="confirmDelete(hospid)" [hidden]="isDeleteHidden(selectedUserRole)"> Delete User </button>
            </div>
          <div class="row"></div>

      </div>
    </div>

  </div>

</ng-container>